import { defineComponent as _defineComponent } from 'vue'
import { defineAsyncComponent, inject, computed, ref, watch } from 'vue'
import { useLocalStorage } from '@vueuse/core'
import { useRoute } from 'vue-router'
import useRouterBack from '@/composables/useRouteBack'
import { LOCAL_STORAGE_CABINET_TABLE_VIEW } from '@/const'


export default /*@__PURE__*/_defineComponent({
  __name: 'CabinetView',
  setup(__props, { expose: __expose }) {
  __expose();

const DefaultLayout = defineAsyncComponent(
  () => import('../components/layouts/DefaultLayout.vue')
)

const route = useRoute()
const layout = computed(() => route.meta?.layout || DefaultLayout)
const currentTitle = inject('currentTitle')

const { goBack, fallbackRouteName } = useRouterBack()

const canChangeTableView = ref(false)

watch(route, () => {
  canChangeTableView.value = false
})

// toggle view

const storageTableView = useLocalStorage<boolean>(LOCAL_STORAGE_CABINET_TABLE_VIEW, false)

function toggleTableAsCards(state: boolean) {
  storageTableView.value = state
}

const __returned__ = { DefaultLayout, route, layout, currentTitle, goBack, fallbackRouteName, canChangeTableView, storageTableView, toggleTableAsCards, defineAsyncComponent, inject, computed, ref, watch, get useLocalStorage() { return useLocalStorage }, get useRoute() { return useRoute }, get useRouterBack() { return useRouterBack }, get LOCAL_STORAGE_CABINET_TABLE_VIEW() { return LOCAL_STORAGE_CABINET_TABLE_VIEW } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})